import { Flex, Text } from "@radix-ui/themes";
import { type ReactNode, type FC, type PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import loginHero from "../../images/login-hero.png";
import { ReactComponent as Logo } from "../../images/Logotype.svg";

export const LoginLayout: FC<
  { customCaption?: ReactNode } & PropsWithChildren<any>
> = ({ children }) => {
  const { t } = useTranslation("components");
  return (
    <section className="flex min-h-screen w-full items-start justify-center bg-puntt-neutral-gray-3 p-0 sm:px-1 sm:py-9 md:px-8">
      <div className="w-full md:flex md:items-start md:justify-between md:gap-16 lg:justify-center">
        {/* Left Column - Login Form */}
        <article className="w-full rounded-2xl md:w-[40vw] md:min-w-[320px] md:max-w-[300px] md:basis-3/5 lg:basis-auto">
          <Flex
            direction="column"
            gap={{ initial: "4", sm: "5" }}
            className="w-full bg-puntt-neutral-gray-3 p-6 sm:rounded-lg sm:bg-base-white sm:py-10 sm:shadow-md"
          >
            <Logo className="mx-auto h-auto w-[160px]" />
            <hr className="hidden border-puntt-neutral-grayA-6 sm:block" />
            {children}
          </Flex>
        </article>

        {/* Right Column - Marketing */}
        <article className="hidden w-[40vw] min-w-[320px] max-w-[512px] md:block">
          <Flex direction="column" gap="5" className="my-10 w-full">
            <Flex direction="column" gap="2" className="px-6 text-center">
              <Text
                as="div"
                size="7"
                weight="bold"
                data-testid="login-marketing-headline"
              >
                Manual reviews.
                <br />
                Automated for marketing teams.
              </Text>
              <Text as="div" size="2" data-testid="login-marketing-body">
                Puntt AI agents review your packaging and marketing collateral,
                so your team gets time back, stays ahead of regulatory risk, and
                catches quality issues before they become rework.
              </Text>
            </Flex>
            <div
              data-testid="login-hero-container"
              className="w-full overflow-hidden rounded-lg shadow-6"
            >
              <img
                src={loginHero}
                alt={t("login.askPunttReviewingPackagingArtwork")}
                data-testid="login-hero-image"
                className="block h-auto w-full max-w-none"
              />
            </div>
          </Flex>
        </article>
      </div>
    </section>
  );
};
